module.exports = __webpack_public_path__ + "img/signature_sample_en.b4d90d5d.png";